import React from "react";
import { Swiper, SwiperSlide } from "components/swiper";
import { Autoplay } from "swiper/modules";
import { ReactComponent as MoneyBack } from "svgs/money-back-guarantee.svg";
import { ReactComponent as Box } from "svgs/box.svg";
import { useSettings } from "hooks/useStore";
import clsx from "clsx/lite";

const ANNOUNCEMENTS = [
	{ icon: <MoneyBack />, text: "30-Days Money Back Guarantee" },
	{ icon: <Box />, text: "Free Shipping on All Orders" },
];

const HighlightAnnouncement = () => {
	const { isMenuOpen } = useSettings(["isMenuOpen"]);

	const settings = {
		loop: true,
		modules: [Autoplay],
		slidesPerView: 1,
		speed: 1400,
		autoplay: {
			delay: 2500,
			disableOnInteraction: false,
		},
	};

	return (
		<div className={clsx(
			"w-full relative bg-transparent transition-all duration-300",
			isMenuOpen ? "max-h-0 p-0 lg:py-2.5 lg:!max-h-14 lg:z-50" : "z-50 max-h-14 py-2.5")}>
			<div className="standard-section-width mx-auto horizontal-padding bg-transparent">
				<Swiper className="md:hidden flex" {...settings}>
					{ANNOUNCEMENTS.map(({ icon, text }, index) => (
						<SwiperSlide key={index} className="w-full text-white">
							<div className="flex justify-center gap-2">
								{icon}
								{text}
							</div>
						</SwiperSlide>
					))}
				</Swiper>
				<div className="hidden md:flex justify-center gap-8 text-white font-bold">
					{ANNOUNCEMENTS.map(({ icon, text }, index) => (
						<div key={index} className="flex items-center gap-2">
							{icon}
							{text}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default HighlightAnnouncement;